import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import VBox from 'components/common/VBox';
import HBox from 'components/common/HBox';

export default function SimulationBox(props) {
  const {
    caption,
    unit,
    variation: {
      arrow,
      value: variationValue,
      type: vairationType,
    },
    before: {
      value: beforeValue,
      type: beforeType,
    },
    after: {
      value: afterValue,
      type: afterType,
    },
    ...rest
  } = props;
  return (
    <VBox {...ex('SimulationBox', rest)}>
      <HBox>
        <div>
          {caption}
        </div>
        <div {...ex(vairationType)}>
          {!variationValue && (
            <svg width={6} height={6} viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx={3} cy={3} r={3} fill="#323D51" />
            </svg>
          )}
          {0 < Math.sign(variationValue) && (
            <svg width={12} height={12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 9.5V2.5M6 2.5L2.5 6M6 2.5L9.5 6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          )}
          {Math.sign(variationValue) < 0 && (
            <svg width={10} height={10} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 1.5V8.5M5 8.5L8.5 5M5 8.5L1.5 5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          )}
          {T('{0}%', Math.abs(variationValue))}
        </div>
      </HBox>
      <HBox>
        <HBox>
          <div {...ex(beforeType)}>
            {beforeValue}
          </div>
          <div {...ex('Unit')}>
            {unit}
          </div>
        </HBox>
        <div>
          <svg width={24} height={25} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_867_3159)">
              <path d="M12 4.5L10.59 5.91L16.17 11.5H4V13.5H16.17L10.59 19.09L12 20.5L20 12.5L12 4.5Z" fill="#D0D0D0" />
            </g>
          </svg>
        </div>
        <HBox>
          <div {...ex(afterType)}>
            {afterValue}
          </div>
          <div {...ex('Unit')}>
            {unit}
          </div>
        </HBox>
      </HBox>
    </VBox>
  );
}

